/* eslint-disable react/prop-types */
import React from "react";
import { useQuery, useApolloClient } from "@apollo/client";
import { Button } from "rbx";
import PageHeader from "../../components/PageHeader";
import { GET_WPS_ROWS, GET_WPS_PDF } from "../../graphql";
import { Table } from "../../components/DataTable";
import { downloadPdfFromDataUrl } from "../../utils";
import "./WPS.scss";


const WPS = () => {
    const apolloClient = useApolloClient();
    const { data, loading, error } = useQuery(GET_WPS_ROWS, { fetchPolicy: "cache-first" });

    const rows = data?.getWpsRows || [];

    const ActionCell = ({ row: rowProp }) => {
        const { externalId, name } = rowProp.original || {};
        return (
            <Button
                color="primary"
                disabled={!externalId}
                onClick={async () => {
                    try {
                        const res = await apolloClient.query({
                            query: GET_WPS_PDF,
                            variables: { externalId },
                            fetchPolicy: "network-only",
                        });
                        const dataUrl = res?.data?.getWpsPdf;
                        if (dataUrl) {
                            await downloadPdfFromDataUrl(dataUrl, `WPS_${externalId || name}.pdf`);
                        }
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.error(e);
                    }
                }}
            >
                Download
            </Button>
        );
    };

    return (
        <div className="wps-page-container">
            <PageHeader title="WPS" />

            {loading && <div>Loading WPS records...</div>}
            {error && <div>Error loading WPS records.</div>}

            {rows?.length > 0 && (
                <div className="wps-table-wrapper" style={{ marginTop: "1.5rem" }}>
                    <Table
                        columns={[
                            { Header: "WPS Name", accessor: "name" },
                            { Header: "Process", accessor: "processTitle" },
                            { Header: "Download", id: "download", Cell: ActionCell },
                        ]}
                        data={rows}
                        onRowClick={() => { }}
                    />
                </div>
            )}

            {!loading && !error && rows?.length === 0 && (
                <div style={{ marginTop: "1.5rem" }}>No WPS records found.</div>
            )}
        </div>
    );
};

export default WPS;